export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.sakn_w_safar_admin_dashboard_language;
  },
  // END:: GET APP LOCALE
};
